// ページヘッダー
export default function pageHeader () {
	const el = document.querySelector('.page-header__bg')
	if (!el) {
		return
	}
	const style = getComputedStyle(el, null)
	const bgImg = style.backgroundImage
	if (!/^url\(/.test(bgImg)) {
		return
	}
	const src = style.backgroundImage.replace(/^url\(['"]?(.+?)['"]?\)/,'$1')
	const img = document.createElement('img');
	img.onload = () => {
		el.classList.add('is--loaded')
	}
	img.src = src
}